/**
 * @generated SignedSource<<3738dba264052da23edac560d64fce29>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type VerificationType = "Slack" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type WebAppSlack_viewer$data = {
  readonly verificationCodeResponse: {
    readonly verificationType: VerificationType | null;
    readonly verificationCode: string | null;
    readonly verificationAttempted: boolean | null;
    readonly valid: boolean | null;
    readonly slackTeam: string | null;
  } | null;
  readonly user: {
    readonly id: string;
    readonly orgs: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
        } | null;
      } | null> | null;
    };
    readonly flowStates: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly flowKey: string | null;
          readonly previousState: string | null;
          readonly current: {
            readonly state: string | null;
            readonly percentComplete: number | null;
            readonly errorMessage: string | null;
          } | null;
          readonly pending: {
            readonly state: string | null;
            readonly percentComplete: number | null;
            readonly errorMessage: string | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentType": "WebAppSlack_viewer";
};
export type WebAppSlack_viewer$key = {
  readonly " $data"?: WebAppSlack_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"WebAppSlack_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000000
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "state",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "percentComplete",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "errorMessage",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WebAppSlack_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "VerificationCodeResponse",
      "kind": "LinkedField",
      "name": "verificationCodeResponse",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "verificationType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "verificationCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "verificationAttempted",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "valid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slackTeam",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": (v1/*: any*/),
          "concreteType": "OrgConnection",
          "kind": "LinkedField",
          "name": "orgs",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrgEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Org",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "orgs(first:1000000)"
        },
        {
          "alias": null,
          "args": (v1/*: any*/),
          "concreteType": "FlowStateConnection",
          "kind": "LinkedField",
          "name": "flowStates",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FlowStateEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FlowState",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "flowKey",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "previousState",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FlowStatus",
                      "kind": "LinkedField",
                      "name": "current",
                      "plural": false,
                      "selections": (v2/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FlowStatus",
                      "kind": "LinkedField",
                      "name": "pending",
                      "plural": false,
                      "selections": (v2/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "flowStates(first:1000000)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "076541bb87f06f63d83560c6d31159db";

export default node;
